
import { visitorService } from "@/service";
import { defineComponent, reactive, toRefs, watch, ref } from "vue";
import { UserInfo } from "./Index.vue";

export interface OtherRef {
  onSearch(searchName: string): void;
}
export default defineComponent({
  name: "Other",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  emits: ["change", "list"],
  setup(props, { emit }) {
    const { data } = toRefs(props);
    watch(
      () => data.value,
      now => {
        state.checked = now;
      }
    );
    const search_value = ref("");
    const state = reactive<any>({
      list: [],
      loading: false,
      finished: false,
      page: 1,
      checked: {}
    });

    const onLoad = async () => {
      try {
        const { data } = await visitorService.visitorTargetLists({
          target_type: 3,
          page: state.page,
          pagesize: 20,
          search_name: search_value.value
        });
        state.list.push(...data.data);
        state.loading = false;
        state.finished = false;
        state.page++;
        if (state.list.length >= data.total) {
          state.finished = true;
        }
      } catch (error) {
        state.list = [];
        state.finished = true;
      }
    };
    const onClick = (user: UserInfo) => {
      state.checked = [user];
      emit("change", user);
    };

    const onSearch = async (from = "self") => {
      if (from === "index") search_value.value = "";
      state.page = 1;
      state.list = [];
      await onLoad();
      if (from === "index") return state.list;
    };
    return {
      state,
      search_value,
      onLoad,
      onClick,
      onSearch
    };
  }
});
